function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamworkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48px",
    width: "48px",
    id: "Layer_1",
    viewBox: "0 0 392.727 392.727",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.267,328.598c-25.6,0-46.998,18.166-52.105,42.279h104.081 C243.265,346.764,221.867,328.598,196.267,328.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M196.267,273.907c8.469,0,15.451-6.982,15.451-15.451s-6.982-15.451-15.451-15.451 s-15.451,6.982-15.451,15.451S187.798,273.907,196.267,273.907z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.267,306.747c-41.309,0-74.925,33.616-74.925,74.925c0,6.012,4.848,10.925,10.925,10.925 h128.194c6.012,0,10.925-4.848,10.925-10.925C271.192,340.428,237.576,306.747,196.267,306.747z M144.162,370.877 c5.042-24.113,26.505-42.279,52.105-42.279s46.998,18.166,52.105,42.279H144.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.267,295.693c20.558,0,37.301-16.679,37.301-37.301c0-20.558-16.679-37.301-37.301-37.301 s-37.301,16.679-37.301,37.301S175.709,295.693,196.267,295.693z M196.267,243.006c8.469,0,15.451,6.982,15.451,15.45 c0,8.469-6.982,15.451-15.451,15.451s-15.451-6.982-15.451-15.451C180.816,249.859,187.798,243.006,196.267,243.006z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M74.925,52.881c8.469,0,15.451-6.982,15.451-15.451S83.394,21.98,74.925,21.98 S59.475,28.962,59.475,37.43S66.457,52.881,74.925,52.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M317.608,107.507c-25.6,0-46.998,18.166-52.105,42.279h104.081 C364.541,125.673,343.143,107.507,317.608,107.507z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M74.925,107.507c-25.6,0-46.998,18.166-52.105,42.279h104.081 C121.988,125.673,100.525,107.507,74.925,107.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M317.608,52.881c8.469,0,15.451-6.982,15.451-15.451s-6.982-15.451-15.451-15.451 c-8.469,0-15.451,6.982-15.451,15.451S309.01,52.881,317.608,52.881z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M74.925,85.721C33.616,85.721,0,119.337,0,160.646c0,6.012,4.848,10.925,10.925,10.925h128.194 c6.012,0,10.925-4.848,10.925-10.925C149.98,119.337,116.299,85.721,74.925,85.721z M22.949,149.786 c5.042-24.113,26.44-42.279,51.976-42.279c25.6,0,46.998,18.166,52.105,42.279H22.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M74.925,74.667c20.558,0,37.301-16.679,37.301-37.301S95.483,0.129,74.925,0.129 S37.689,16.808,37.689,37.43S54.368,74.667,74.925,74.667z M74.925,21.915c8.469,0,15.451,6.982,15.451,15.451 s-6.982,15.451-15.451,15.451s-15.451-6.917-15.451-15.451S66.457,21.915,74.925,21.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M317.608,85.721c-41.309,0-74.925,33.616-74.925,74.925c0,6.012,4.848,10.925,10.925,10.925h128.194 c6.012,0,10.925-4.848,10.925-10.925C392.533,119.337,358.917,85.721,317.608,85.721z M265.503,149.786 c5.042-24.113,26.505-42.279,52.105-42.279s46.998,18.166,52.105,42.279H265.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M317.608,74.667c20.558,0,37.301-16.679,37.301-37.301S338.166,0.129,317.608,0.129 c-20.558,0-37.301,16.679-37.301,37.301S297.051,74.667,317.608,74.667z M317.608,21.915c8.469,0,15.451,6.982,15.451,15.451 s-6.982,15.451-15.451,15.451c-8.469,0-15.451-6.982-15.451-15.451S309.01,21.915,317.608,21.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M249.212,55.984l-22.238-32.388c-3.426-4.978-10.15-6.206-14.998-2.78l-0.259,0.129 c-4.978,3.426-6.206,10.149-2.78,14.998l6.594,9.568c-26.182-3.426-53.075,0.065-77.834,10.343l-0.065,0.065 c-5.495,2.327-8.145,8.598-5.818,14.158l0.129,0.129c2.327,5.495,8.598,8.145,14.158,5.818l0.065-0.065 c21.398-8.857,44.735-11.895,67.362-8.792l-11.895,8.21c-4.913,3.426-6.206,10.149-2.78,14.998l0.129,0.259 c3.426,4.913,10.15,6.206,14.998,2.78l32.388-22.238C251.345,67.749,252.703,60.962,249.212,55.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M117.075,299.96c-18.36-14.093-32.517-32.776-41.244-53.915l12.8,6.077 c5.43,2.651,11.96,0.323,14.545-5.172c2.651-5.43,0.323-11.96-5.172-14.545l-35.297-16.873c-5.43-2.651-11.96-0.323-14.545,5.172 l-16.873,35.362c-2.651,5.43-0.323,11.96,5.172,14.545l0,0c5.43,2.651,11.96,0.323,14.545-5.172l5.042-10.602 c10.214,24.501,26.505,46.028,47.774,62.384c4.784,3.62,11.572,2.78,15.321-2.004C122.764,310.432,121.859,303.644,117.075,299.96z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M337.778,203.83c-5.947-0.776-11.442,3.426-12.218,9.438c-3.038,22.949-12.154,44.541-26.117,62.642 l-1.099-14.158c-0.453-6.012-5.689-10.537-11.766-10.02l0,0c-6.012,0.453-10.537,5.689-10.02,11.766l3.103,39.046 c0.453,6.012,5.689,10.537,11.766,10.02l39.046-3.103c6.012-0.453,10.537-5.689,10.02-11.766l0,0 c-0.453-6.012-5.689-10.537-11.766-10.02l-11.507,0.905c16.097-21.01,26.505-45.964,29.996-72.533 C347.927,209.972,343.79,204.606,337.778,203.83z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamworkIcon);
export default __webpack_public_path__ + "static/media/teamwork-icon.8634526c.svg";
export { ForwardRef as ReactComponent };